// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Subscriptions_AdminSweepRunOutcomeRow.php
// Do not edit by hand — edit the PHP RowContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Subscriptions_AdminSweepRunOutcomeRow — what one round did to ONE candidate.
 *
 * Stored inside subscription_sweep_runs.outcomes (JSON) and emitted decoded on
 * GET /subscriptions/admin/sweep/runs.
 *
 * outcome vocabulary — the cancellation service's own codes plus the three the
 * sweep itself produces:
 *   cancelled | deferred | refused | gateway_failed | local_write_failed
 *   not_due   — the single-row door found the carência window still open
 *   skipped   — the circuit breaker refused the round before touching this row
 *   not_found — the named subscription does not exist
 *
 * reason is the machine code behind a non-cut ('retry_scheduled',
 * 'circuit_open', 'gateway_not_registered', …), NULL when there is nothing to
 * explain.
 */
import { registerContract } from './validate'

export interface Subscriptions_AdminSweepRunOutcomeRow {
subscription_id?: number
outcome?: string
reason?: string
}

registerContract('Subscriptions_AdminSweepRunOutcomeRow', {
  subscription_id: { type: 'number',  required: false },
  outcome:         { type: 'string',  required: false },
  reason:          { type: 'string',  required: false },
})
